
import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="py-24 bg-slate-900">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-white mb-4">
          Ready to transform your trade business?
        </h2>
        <p className="text-xl text-slate-300 mb-8">
          Join Australian tradies who've simplified their job management with MTA Planner Pro.
        </p>
        <Link
          to="/demo"
          className="inline-block px-8 py-4 bg-amber-500 text-slate-900 font-semibold rounded-lg hover:bg-amber-400 transition-colors whitespace-nowrap"
        >
          Start Free Trial
        </Link>
      </div>
    </section>
  );
}
